import { useContext } from 'react';
import { getScaleObject, getDeathTypeObject } from './store/StaticVariables';
import { InterfaceContext } from './store/InterfaceProvider';

const MapTitle = () => {
    const { activeViewType, activeMeasurement, activeDeathType, activeTimePeriod, activeScale, activePast12Months } = useContext(InterfaceContext);

    const getCountStr = () => {
        return activeMeasurement === 'count' ? 'Number of ' : '';
    };

    const getCauseStr = () => {
        if (activeViewType !== 'deaths') return 'Firearm Injury Emergency Department (ED) Visit';
        const addS = activeMeasurement === 'count' ? 's' : '';
        return String(getDeathTypeObject(activeDeathType).title.replace(/eaths/, 'eath') + addS);
    };

    const getRateStr = () => {
        if (activeMeasurement !== 'rate') return '';
        return activeViewType === 'deaths' ? 'Rate per 100,000 People' : 'Rate per 100,000 ED Visits';
    };

    const getGeoStr = () => {
        return getScaleObject(activeScale).label;
    };

    const getTimeStr = () => {
        return activeTimePeriod === 'ttm' ? activePast12Months : activeTimePeriod;
    };
    const getIsProvisionalData = () => {
        if (activeViewType !== 'deaths') return false;
        return activeTimePeriod === 'ttm';
    };
    const getProvisionalStr = () => {
        if (!getIsProvisionalData()) return;
        return ' (Provisional Data)';
    };

    const str = {
        count: getCountStr(),
        cause: getCauseStr(),
        rate: getRateStr(),
        geo: getGeoStr(),
        time: getTimeStr(),
        provisional: getProvisionalStr()
    };

    return (
        <p id="mapTitle" className="">
            <span>
                {str.count + str.cause} {str.rate} by {str.geo}, {str.time}
                {str.provisional}
            </span>
        </p>
    );
};
export default MapTitle;
